/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class BackupPolicySecurityConfig {
  /**
  * The ID of the policy
  */
  'id': string;
  /**
  * Whether security scans are enabled for the policy resources
  */
  'enabled': boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "enabled",
      "baseName": "enabled",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BackupPolicySecurityConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

